import { RouteLocationNormalizedGeneric } from 'vue-router'
import { LOGIN_COUNTRY_SEO, resolveLoginCountrySeo } from '@/micro/modules/seo'
import { BASE_URL } from '@/micro/utils/environment'

const SEO_ATTRIBUTE = 'data-seo'

const removeSeoTags = () => {
  document.head.querySelectorAll(`link[${SEO_ATTRIBUTE}]`).forEach(tag => tag.remove())
}

const appendLink = ({ rel, href, hreflang }: { rel: string; href: string; hreflang?: string }) => {
  const link = document.createElement('link')
  link.rel = rel
  link.href = href

  if (hreflang) {
    link.hreflang = hreflang
  }

  link.setAttribute(SEO_ATTRIBUTE, hreflang ? 'hreflang' : 'canonical')
  document.head.appendChild(link)
}

const getLoginCountryUrl = (slug: string) => `${BASE_URL}user/login/country/${slug}`

export default function () {
  const setSeoMetadata = (route: RouteLocationNormalizedGeneric) => {
    removeSeoTags()

    if (route?.name !== 'login-by-country') return

    const countrySeo = resolveLoginCountrySeo(route.params.country)
    if (!countrySeo) return

    appendLink({ rel: 'canonical', href: getLoginCountryUrl(countrySeo.slug) })

    LOGIN_COUNTRY_SEO.forEach(seo => {
      appendLink({
        rel: 'alternate',
        hreflang: seo.hreflang,
        href: getLoginCountryUrl(seo.slug),
      })
    })
  }

  return { setSeoMetadata }
}
